/**
 * Browser identification for the handful of places where a specific browser
 * behaves differently enough to warrant telling the user.
 *
 * Deliberately NOT in services/firebase — none of this is Firebase-related.
 * `isSamsungInternet` previously lived in firebase/messaging.js, which tied a
 * general browser concern to push notifications and made the guidance surface
 * only on the notifications screen (#204).
 */

/**
 * Samsung Internet — the default browser on Galaxy devices.
 *
 * It mishandles PWA version detection and tells the user the app is on a wrong
 * version (#204). That is a Samsung behaviour, not something we can fix from
 * our side, so the only useful response is to point the user at Chrome.
 *
 * User-agent sniffing is brittle by nature. This is a pragmatic route to a
 * browser where the app behaves as intended, not a claim that Samsung Internet
 * is unsupported.
 *
 * @param {string} [userAgent] Override, for tests.
 * @return {boolean}
 */
export function isSamsungInternet(userAgent) {
  const ua = userAgent ?? (typeof navigator === 'undefined' ? '' : navigator.userAgent)
  return /SamsungBrowser/i.test(ua || '')
}
